import React, { useState } from 'react';
import { SETTINGS_CONFIG } from '../content/settings';

function Settings({ app }) {
  const [settings, setSettings] = useState(SETTINGS_CONFIG);

  const handleSliderChange = (categoryId, settingId, value) => {
    setSettings(prev => ({
      ...prev,
      [categoryId]: {
        ...prev[categoryId],
        settings: prev[categoryId].settings.map(setting => 
          setting.id === settingId ? {...setting, value} : setting
        )
      }
    }));
  };

  const handleToggleChange = (categoryId, settingId) => {
    setSettings(prev => ({
      ...prev,
      [categoryId]: {
        ...prev[categoryId],
        settings: prev[categoryId].settings.map(setting => 
          setting.id === settingId ? {...setting, value: !setting.value} : setting
        )
      }
    }));
  };

  const handleSelectChange = (categoryId, settingId, value) => {
    setSettings(prev => ({
      ...prev,
      [categoryId]: {
        ...prev[categoryId],
        settings: prev[categoryId].settings.map(setting => 
          setting.id === settingId ? {...setting, value} : setting
        )
      }
    }));
  };

  const renderSetting = (categoryId, setting) => {
    switch (setting.type) {
      case 'slider':
        return (
          <div className="flex items-center gap-4">
            <input
              type="range"
              min={setting.min}
              max={setting.max}
              value={setting.value}
              onChange={(e) => handleSliderChange(categoryId, setting.id, parseInt(e.target.value))}
              className="w-full bg-purple-900 accent-amber-300"
            />
            <span className="text-white w-12">{setting.value}%</span>
          </div>
        );
      
      case 'toggle':
        return (
          <div className="flex items-center">
            <button
              onClick={() => handleToggleChange(categoryId, setting.id)}
              className={`w-12 h-7 rounded-full transition-colors ${
                setting.value ? 'bg-purple-900' : 'bg-gray-600'
              }`}
            >
              <div className={`w-5 h-5 rounded-full bg-amber-300 border border-white shadow-sm transition-transform transform ${
                setting.value ? 'translate-x-6' : 'translate-x-1'
              }`} />
            </button>
          </div>
        );

      case 'select':
        return (
          <select
            value={setting.value}
            onChange={(e) => handleSelectChange(categoryId, setting.id, e.target.value)}
            className="bg-black bg-opacity-45 text-white rounded-xl px-4 py-2 border border-white focus:outline-none focus:ring-2 focus:ring-amber-300"
          >
            {setting.options.map(option => (
              <option key={option} value={option}>
                {option.charAt(0).toUpperCase() + option.slice(1)}
              </option>
            ))}
          </select>
        );

      default:
        return null;
    }
  };

  return (
    <div className="h-full w-full flex flex-col bg-gradient-to-b from-violet-500 to-sky-400 p-6 overflow-auto">
      <div className="max-w-md mx-auto w-full">
        <h2 className="text-3xl font-bold text-amber-300 mb-6 font-['Arial']">SETTINGS</h2>

        {Object.entries(settings).map(([categoryId, category]) => (
          <div key={categoryId} className="mb-8">
            <h3 className="text-lg font-bold text-white mb-4 font-['Arial']">{category.label}</h3>
            <div className="space-y-4">
              {category.settings.map(setting => (
                <div key={setting.id} className="bg-black bg-opacity-45 rounded-2xl p-6 shadow-sm border border-white">
                  <div className="flex justify-between items-center">
                    <label className="text-white font-bold font-['Arial']">{setting.label}</label>
                    {renderSetting(categoryId, setting)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Settings;
